"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Accordion = _interopRequireDefault(require("@mui/material/Accordion"));
var _AccordionSummary = _interopRequireDefault(require("@mui/material/AccordionSummary"));
var _AccordionDetails = _interopRequireDefault(require("@mui/material/AccordionDetails"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const AccordionList = _ref => {
  var _defaultExpandedIndex;
  let _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$allowMultiple = _ref.allowMultiple,
    allowMultiple = _ref$allowMultiple === void 0 ? false : _ref$allowMultiple,
    _ref$defaultExpandedI = _ref.defaultExpandedIndexes,
    defaultExpandedIndexes = _ref$defaultExpandedI === void 0 ? [] : _ref$defaultExpandedI;
  const _React$useState = React.useState(allowMultiple ? defaultExpandedIndexes : (_defaultExpandedIndex = defaultExpandedIndexes[0]) !== null && _defaultExpandedIndex !== void 0 ? _defaultExpandedIndex : false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    expanded = _React$useState2[0],
    setExpanded = _React$useState2[1];
  const handleChange = index => (_, isExpanded) => {
    if (allowMultiple) {
      setExpanded(prev => isExpanded ? [...prev, index] : prev.filter(i => i !== index));
    } else {
      setExpanded(isExpanded ? index : false);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: items.map((item, index) => {
      const isExpanded = allowMultiple ? expanded.includes(index) : expanded === index;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Accordion.default, {
        expanded: isExpanded,
        onChange: handleChange(index),
        elevation: 0,
        disableGutters: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionSummary.default, {
          expandIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandMore.default, {}),
          sx: {
            px: 0,
            m: 0,
            '&.Mui-expanded': {
              minHeight: 'unset',
              m: 0
            },
            '& .MuiAccordionSummary-content': {
              m: 0
            },
            '& .MuiAccordionSummary-content.Mui-expanded': {
              m: 0
            }
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            fontSize: 14,
            fontWeight: 500,
            children: item.question
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionDetails.default, {
          sx: {
            px: 0
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            fontSize: 12,
            color: "#585969",
            children: item.answer
          })
        })]
      }, index);
    })
  });
};
var _default = exports.default = AccordionList;